module.exports = __webpack_public_path__ + "img/img_9.ef239cf0.jpg";